module.exports = __webpack_public_path__ + "04_long_black.823ba5a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/04_long_black.png
// module id = VNUk
// module chunks = 0